import AbstractNetworkStatus from '../all/AbstractNetworkStatus';

class KeplerNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    console.log('[NetworkStatus] checking Kepler...');
    return this.onlineByAjax();
  }

}

export default KeplerNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/kepler/NetworkStatus.js